<template>
  <div class="main-wrapper">
    <table>
      <tr>
        <td class="left-column">
          <p>Полное наименование организации</p>
        </td>
        <td>
          <textarea
            class="textarea-input"
            cols="65"
            v-model="pageInfo.ORG_FULL_NAME"
            :disabled="true"
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>Сокращенное наименование организации</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="pageInfo.ORG_BRIEF_NAME"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.FULL_FOREIGN_NAME != null &&
                sendData.FULL_FOREIGN_NAME.length == 0 &&
                !haveEng
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Полное наименование на иностранном языке
          </p>

          <label>
            <input
              type="checkbox"
              v-model="haveEng"
              id="checkboxEnglishName"
              @click="
                sendData.FULL_FOREIGN_NAME = '';
                isUpdate = true;
              "
              :disabled="
                pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('FULL_FOREIGN_NAME') != -1
              "
            />
            Полное наименование на иностранном языке отсутствует
          </label>
        </td>
        <td>
          <input
            type="text"
            placeholder="Заполняется в соответствии с Уставом"
            class="input-line"
            v-model="sendData.FULL_FOREIGN_NAME"
            @input="
              fullEngNameInput();
              isUpdate = true;
            "
            :disabled="
              haveEng ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('FULL_FOREIGN_NAME') != -1)
            "
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.BRIEF_FOREIGN_NAME != null &&
                sendData.BRIEF_FOREIGN_NAME.length == 0 &&
                !haveBriefEng
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Сокращенное наименование на иностранном языке
          </p>
          <label>
            <input
              type="checkbox"
              v-model="haveBriefEng"
              id="checkboxEnglishName"
              @click="
                sendData.BRIEF_FOREIGN_NAME = '';
                isUpdate = true;
              "
              :disabled="
                pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('BRIEF_FOREIGN_NAME') != -1
              "
            />Сокращенное наименование на иностранном языке отсутствует
          </label>
        </td>
        <td>
          <input
            type="text"
            placeholder="Заполняется в соответствии с Уставом"
            class="input-line"
            v-model="sendData.BRIEF_FOREIGN_NAME"
            @input="
              briefEngNameInput();
              isUpdate = true;
            "
            :disabled="
              haveBriefEng ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('BRIEF_FOREIGN_NAME') != -1)
            "
          />
        </td>
      </tr>
      <!-- <tr>
        <td class="left-column">
          <p>Статус организации</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model="pageInfo.STATUS_STRING"
            :disabled="true"
          />
        </td>
      </tr> -->
      <tr>
        <td class="left-column">
          <p>Адрес места нахождения (из ЕГРЮЛ)</p>
        </td>
        <td>
          <textarea
            class="textarea-input"
            cols="65"
            v-model="pageInfo.UR_ADDRESS"
            :disabled="true"
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.FACT_ADDRESS != null &&
                sendData.FACT_ADDRESS.length == 0 &&
                !actualAddressLikeLegal
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Фактический адрес
          </p>
          <input
            type="checkbox"
            id="adressFact"
            v-model="actualAddressLikeLegal"
            :checked="
              actualAddressLikeLegal
                ? (sendData.FACT_ADDRESS = pageInfo.UR_ADDRESS)
                : sendData.FACT_ADDRESS
            "
            @click="
              sendData.FACT_ADDRESS = '';
              isUpdate = true;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('FACT_ADDRESS') != -1
            "
          />
          <label for="adressFact">Cовпадает с адресом места нахождения</label>
        </td>
        <td>
          <textarea
            class="textarea-input"
            cols="65"
            placeholder="При несовпадении с юридическим необходимо обратиться в ИФНС для внесения изменений"
            v-model="sendData.FACT_ADDRESS"
            :disabled="
              actualAddressLikeLegal ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('FACT_ADDRESS') != -1)
            "
            @input="
              isUpdate = true;
              sendData.FACT_ADDRESS != null &&
              sendData.FACT_ADDRESS.length > 1000
                ? (sendData.FACT_ADDRESS = sendData.FACT_ADDRESS.substr(
                    0,
                    1000
                  ))
                : sendData.FACT_ADDRESS;
            "
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.POST_ADDRESS != null &&
                sendData.POST_ADDRESS.length == 0 &&
                !mailAddressLikeActual &&
                !mailAddressLikeLegal
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Почтовый адрес
          </p>
          <div class="checkboxes">
            <label>
              <input
                type="checkbox"
                id="mailUrid"
                v-model="mailAddressLikeLegal"
                :checked="
                  !mailAddressLikeActual && mailAddressLikeLegal
                    ? (sendData.POST_ADDRESS = pageInfo.UR_ADDRESS)
                    : sendData.POST_ADDRESS
                "
                @click="
                  sendData.POST_ADDRESS = '';
                  mailAddressLikeActual = false;
                  isUpdate = true;
                "
                :disabled="
                  pageInfo.DISABLED != null &&
                    pageInfo.DISABLED.indexOf('POST_ADDRESS') != -1
                "
              />Cовпадает с адресом места нахождения
            </label>

            <label>
              <input
                type="checkbox"
                id="mailFact"
                v-model="mailAddressLikeActual"
                :checked="
                  mailAddressLikeActual && !mailAddressLikeLegal
                    ? (sendData.POST_ADDRESS = sendData.FACT_ADDRESS)
                    : sendData.POST_ADDRESS
                "
                @click="
                  sendData.POST_ADDRESS = '';
                  mailAddressLikeLegal = false;
                  isUpdate = true;
                "
                :disabled="
                  pageInfo.DISABLED != null &&
                    pageInfo.DISABLED.indexOf('POST_ADDRESS') != -1
                "
              />Cовпадает с фактичеcким адресом
            </label>
          </div>
        </td>
        <td>
          <textarea
            class="textarea-input"
            cols="65"
            v-model="sendData.POST_ADDRESS"
            :disabled="
              mailAddressLikeActual ||
                mailAddressLikeLegal ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('POST_ADDRESS') != -1)
            "
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                (sendData.EMAIL != null && sendData.EMAIL.length == 0) ||
                unvalidEmail
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Адрес электронной почты
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="sendData.EMAIL"
            v-bind:class="
              unvalidEmail ? 'necessary-unvalid' : 'necessary-valid'
            "
            placeholder="example@mail.com"
            @blur="checkEmail()"
            @input="
              isUpdate = true;
              sendData.EMAIL != null && sendData.EMAIL.length > 100
                ? (sendData.EMAIL = sendData.EMAIL.substr(0, 100))
                : sendData.EMAIL;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('EMAIL') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidEmail">
            Введите корректный адрес электронной почты
          </p>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                sendData.AUX_EMAIL == null || !unvalidAuxEmail
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Адрес электронной почты (дополнительный)
          </p>
          <p></p>
        </td>
        <td>
          <input
            type="text"
            v-model="sendData.AUX_EMAIL"
            v-bind:class="
              unvalidEmail ? 'necessary-unvalid' : 'necessary-valid'
            "
            placeholder="example@mail.com"
            @blur="checkAuxEmail()"
            @input="
              isUpdate = true;
              sendData.AUX_EMAIL != null && sendData.AUX_EMAIL.length > 100
                ? (sendData.AUX_EMAIL = sendData.AUX_EMAIL.substr(0, 100))
                : sendData.AUX_EMAIL;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('AUX_EMAIL') != -1
            "
          />
          <p class="necessary-message" v-if="unvalidAuxEmail">
            Введите корректный адрес электронной почты
          </p>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                (!haveSite &&
                  sendData.WEB_SITE != null &&
                  sendData.WEB_SITE.length == 0) ||
                unvalidSite
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Сайт
          </p>
          <input
            type="checkbox"
            v-model="haveSite"
            id="checkboxSite"
            @click="
              siteChecked();
              isUpdate = true;
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('WEB_SITE') != -1
            "
          />
          <label for="checkboxSite">Сайт отсутствует</label>
        </td>
        <td>
          <input
            type="text"
            v-bind:class="unvalidSite ? 'necessary-unvalid' : 'necessary-valid'"
            v-model="sendData.WEB_SITE"
            :disabled="
              haveSite ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('WEB_SITE') != -1)
            "
            @blur="checkSite()"
            @input="
              isUpdate = true;
              sendData.WEB_SITE != null && sendData.WEB_SITE.length > 80
                ? (sendData.WEB_SITE = sendData.WEB_SITE.substr(0, 80))
                : sendData.WEB_SITE;
            "
          />
          <p class="necessary-message" v-if="unvalidSite">
            Введите корректный адрес сайта
          </p>
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                !unvalidAuxSite || haveSite ? 'valid-field' : 'unvalid-field'
              "
              >➤</span
            >
            Сайт (дополнительный)
          </p>
        </td>
        <td>
          <input
            type="text"
            v-bind:class="
              unvalidAuxSite ? 'necessary-unvalid' : 'necessary-valid'
            "
            v-model="sendData.AUX_WEB_SITE"
            :disabled="
              haveSite ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('WEB_SITE') != -1)
            "
            @blur="checkAuxSite()"
            @input="
              isUpdate = true;
              sendData.AUX_WEB_SITE != null && sendData.AUX_WEB_SITE.length > 80
                ? (sendData.AUX_WEB_SITE = sendData.AUX_WEB_SITE.substr(0, 80))
                : sendData.AUX_WEB_SITE;
            "
          />
          <p class="necessary-message" v-if="unvalidAuxSite">
            Введите корректный адрес сайта
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <span
              :class="
                sendData.PHONE_NUMBER != null &&
                sendData.PHONE_NUMBER.length != 18
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Телефон
          </p>
        </td>
        <td class="row">
          <input
            type="text"
            v-mask="'+7 (###) ###-##-##'"
            class="telephone-lines"
            v-model="sendData.PHONE_NUMBER"
            placeholder="+7 (###) ###-##-##"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PHONE_NUMBER') != -1
            "
          />
          <input
            type="text"
            v-mask="'########'"
            class="telephone-lines"
            v-model="sendData.PHONE_APPEND"
            placeholder="доб. номер (если есть)"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('PHONE_APPEND') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <span
              :class="
                (sendData.AUX_PHONE_NUMBER != null &&
                  (sendData.AUX_PHONE_NUMBER.length == 18 ||
                    sendData.AUX_PHONE_NUMBER.length == 0)) ||
                sendData.AUX_PHONE_NUMBER == null
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Телефон (дополнительный)
          </p>
        </td>
        <td>
          <input
            type="text"
            v-mask="'+7 (###) ###-##-##'"
            class="telephone-lines"
            v-model="sendData.AUX_PHONE_NUMBER"
            placeholder="+7 (###) ###-##-##"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('AUX_PHONE_NUMBER') != -1
            "
          />
          <input
            type="text"
            v-mask="'########'"
            class="telephone-lines"
            v-model="sendData.AUX_PHONE_APPEND"
            placeholder="доб. номер (если есть)"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('AUX_PHONE_APPEND') != -1
            "
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКФС</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'##'"
            v-model="pageInfo.OKFS"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКПО</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'##########'"
            v-model="pageInfo.OKPO"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКОПФ</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'#####'"
            v-model="pageInfo.OKOPF"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКАТО</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'###########'"
            v-model="pageInfo.OKATO"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКТМО</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'###########'"
            v-model="pageInfo.OKTMO"
            disabled
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p>ОКОГУ</p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-mask="'#######'"
            v-model="pageInfo.OKOGU"
            :disabled="true"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                stuffCount != null && stuffCount == '0'
                  ? 'unvalid-field'
                  : 'valid-field'
              "
              >➤</span
            >
            Среднесписочная численность
          </p>
        </td>
        <td>
          <input
            type="text"
            class="input-line"
            v-model.lazy="stuffCount"
            v-money="money"
            :onchange="onChangeStuffCount()"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('STUFF_COUNT') != -1
            "
          />
        </td>
      </tr>
    </table>

    <div class="data-is-right-checkboxes">
      <label>
        <input
          type="checkbox"
          v-model="dataIsRight[0]"
          @click="
            dataIsRight = [dataIsRight[0], false];
            invalidData = '';
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('COMPANY_DATA_VALID') != -1
          "
        />Данные верны
      </label>
      <label>
        <input
          type="checkbox"
          v-model="dataIsRight[1]"
          @click="
            dataIsRight = [false, dataIsRight[1]];
            invalidData = '';
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('COMPANY_DATA_VALID') != -1
          "
        />Внести изменения
      </label>
    </div>
    <div v-if="dataIsRight[1]" class="invalid-data">
      <p class="necessary-bold">
        <span
          :class="
            invalidData != null && invalidData.length > 0
              ? 'valid-field'
              : 'unvalid-field'
          "
          >➤</span
        >
        Укажите строку, в которой указаны неверные данные и укажите верные
        данные
      </p>
      <textarea
        class="invalid-data-textarea"
        v-model="invalidData"
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf(
              'GENERAL_INFO_WITH_STATCODES_INVALID_DATA'
            ) != -1
        "
      ></textarea>
    </div>
  </div>
</template>

<script>
import { VMoney } from "v-money";
import mask from "./utils/my-mask.js";

export default {
  name: "CompanyInformation",
  props: {
    pageInfo: {},
    pageName: String,
  },
  directives: { money: VMoney },
  data() {
    return {
      haveEng: false,
      haveSite: false,
      noContent: true,
      unvalidEmail: false,
      unvalidAuxSite: false,
      unvalidSite: false,
      actualAddressLikeLegal: false,
      mailAddressLikeActual: false,
      unvalidAuxEmail: false,
      invalidData: "",
      stuffCount: "",
      isUpdate: false,
      haveBriefEng: false,
      mailAddressLikeLegal: false,
      ustavLike: [false, false],
      sendData: {
        POST_ADDRESS: "",
        EMAIL: "",
        AUX_EMAIL: "",
        FACT_ADDRESS: "",
        STUFF_COUNT: "",
        FULL_FOREIGN_NAME: "",
        BRIEF_FOREIGN_NAME: "",
        WEB_SITE: "",
        AUX_WEB_SITE: "",
        AUX_PHONE_NUMBER: "",
        AUX_PHONE_APPEND: "",
        PHONE_NUMBER: "",
        PHONE_APPEND: "",
      },
      dataIsRight: [false, false],
      money: {
        decimal: ",",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  methods: {
    fullEngNameInput() {
      if (
        this.sendData.FULL_FOREIGN_NAME != null &&
        this.sendData.FULL_FOREIGN_NAME.length > 1000
      )
        this.sendData.FULL_FOREIGN_NAME = this.sendData.FULL_FOREIGN_NAME.substr(
          0,
          1000
        );
      this.sendData.FULL_FOREIGN_NAME = this.sendData.FULL_FOREIGN_NAME.replace(
        /[^0-9a-zA-Z- _,.&:]/g,
        ""
      );
    },
    briefEngNameInput() {
      if (
        this.sendData.BRIEF_FOREIGN_NAME != null &&
        this.sendData.BRIEF_FOREIGN_NAME.length > 1000
      )
        this.sendData.BRIEF_FOREIGN_NAME = this.sendData.BRIEF_FOREIGN_NAME.substr(
          0,
          1000
        );
      this.sendData.BRIEF_FOREIGN_NAME = this.sendData.BRIEF_FOREIGN_NAME.replace(
        /[^0-9a-zA-Z- _,.&:]/g,
        ""
      );
    },
    onChangeStuffCount() {
      if (this.stuffCount.length > 12)
        this.stuffCount = this.stuffCount.substr(0, 12);
    },
    validField(field) {
      return field == null || (field != null && field.length == 0);
    },
    validation() {
      var msg = "";
      if (this.validField(this.sendData.FULL_FOREIGN_NAME) && !this.haveEng)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Полное наименование на иностранном языке<br>"
            : "• Полное наименование на иностранном языке<br>";
      if (
        this.validField(this.sendData.BRIEF_FOREIGN_NAME) &&
        !this.haveBriefEng
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Сокращенное наименование на иностранном языке<br>"
            : "• Сокращенное наименование на иностранном языке<br>";
      if (this.validField(this.sendData.POST_ADDRESS))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Почтовый адрес<br>"
            : "• Почтовый адрес<br>";

      if (this.validField(this.sendData.FACT_ADDRESS))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Фактический адрес<br>"
            : "• Фактический адрес<br>";
      if (
        (this.validField(this.sendData.WEB_SITE) && !this.haveSite) ||
        this.unvalidSite
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Адрес сайта<br>"
            : "• Адрес сайта<br>";
      if (this.validField(this.sendData.EMAIL) || this.unvalidEmail)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Адрес электронной почты<br>"
            : "• Адрес электронной почты<br>";

      if (this.stuffCount == "0")
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Среднесписочная численность<br>"
            : "• Среднесписочная численность<br>";
      if (this.sendData.PHONE_NUMBER.length != 18)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Номер телефона<br>"
            : "• Номер телефона<br>";
      if (this.dataIsRight[1] && this.validField(this.invalidData))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>"
            : "• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>";
      if (this.unvalidEmai)
        msg += "Корректно введите адрес электронной почты<br>";
      if (!(this.dataIsRight[0] || this.dataIsRight[1]))
        msg += "Подтвердите корректность данных, заполненных автоматически";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.sendData.STUFF_COUNT = parseInt(
          this.stuffCount.split(" ").join("")
        );
        this.sendData.COMPANY_DATA_VALID = this.dataIsRight[0];
        this.sendData.FACT_ADDRESS_SAME_UR =
          this.pageInfo.UR_ADDRESS == this.sendData.FACT_ADDRESS;
        if (this.sendData.COMPANY_DATA_VALID)
          delete this.sendData.GENERAL_INFO_WITH_STATCODES_INVALID_DATA;
        else
          this.sendData.GENERAL_INFO_WITH_STATCODES_INVALID_DATA = this.invalidData;
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
    siteChecked() {
      this.sendData.WEB_SITE = "";
      this.sendData.AUX_WEB_SITE = "";
      this.unvalidAuxSite = false;
      this.unvalidSite = false;
    },
    checkSite() {
      this.unvalidSite = mask.siteCheck(this.sendData.WEB_SITE);
    },
    checkAuxSite() {
      this.unvalidAuxSite = mask.siteCheck(this.sendData.AUX_WEB_SITE);
    },
    checkEmail() {
      this.unvalidEmail = mask.emailCheck(this.sendData.EMAIL);
    },
    checkAuxEmail() {
      this.unvalidAuxEmail = mask.emailCheck(this.sendData.AUX_EMAIL);
    },
    onCheckActualAddress() {
      this.sendData.FACT_ADDRESS = "";
      if (!this.actualAddressLikeLegal)
        this.sendData.FACT_ADDRESS = this.pageInfo.UR_ADDRESS;
    },

    onCheckMailAddressLegal() {
      this.sendData.POST_ADDRESS = "";
      this.mailAddressLikeActual = false;
      if (!this.mailAddressLikeLegal)
        this.sendData.POST_ADDRESS = this.pageInfo.UR_ADDRESS;
    },
    onCheckMailAddressActual(item) {
      this.sendData.POST_ADDRESS = "";
      this.mailAddressLikeLegal = false;
      console.log(item);
      if (!this.mailAddressLikeActual)
        this.sendData.POST_ADDRESS = this.sendData.FACT_ADDRESS;
    },
    fillInfo() {
      if (this.pageInfo.FACT_ADDRESS != null) {
        this.sendData.FACT_ADDRESS = this.pageInfo.FACT_ADDRESS;
      }
      if (this.pageInfo.BRIEF_FOREIGN_NAME != null) {
        this.sendData.BRIEF_FOREIGN_NAME = this.pageInfo.BRIEF_FOREIGN_NAME;
      }
      if (this.pageInfo.POST_ADDRESS != null) {
        {
          if (this.pageInfo.FULL_FOREIGN_NAME != null) {
            this.sendData.FULL_FOREIGN_NAME = this.pageInfo.FULL_FOREIGN_NAME;
          } else {
            this.haveEng = true;
          }
          if (this.pageInfo.BRIEF_FOREIGN_NAME != null) {
            this.sendData.BRIEF_FOREIGN_NAME = this.pageInfo.BRIEF_FOREIGN_NAME;
          } else {
            this.haveBriefEng = true;
          }
          if (this.pageInfo.WEB_SITE != null) {
            {
              this.sendData.WEB_SITE = this.pageInfo.WEB_SITE;
              if (this.pageInfo.AUX_WEB_SITE != null) {
                this.sendData.AUX_WEB_SITE = this.pageInfo.AUX_WEB_SITE;
              }
            }
          } else {
            this.haveSite = true;
          }
          this.sendData.POST_ADDRESS = this.pageInfo.POST_ADDRESS;
        }
      }
      if (this.pageInfo.EMAIL != null) {
        this.sendData.EMAIL = this.pageInfo.EMAIL;
      }
      if (this.pageInfo.AUX_EMAIL != null) {
        this.sendData.AUX_EMAIL = this.pageInfo.AUX_EMAIL;
      }
      if (this.pageInfo.AUX_PHONE_NUMBER != null) {
        this.sendData.AUX_PHONE_NUMBER = this.pageInfo.AUX_PHONE_NUMBER;
      }
      if (this.pageInfo.AUX_PHONE_APPEND != null) {
        this.sendData.AUX_PHONE_APPEND = this.pageInfo.AUX_PHONE_APPEND;
      }
      if (this.pageInfo.COMPANY_DATA_VALID != null) {
        this.dataIsRight = [
          this.pageInfo.COMPANY_DATA_VALID,
          !this.pageInfo.COMPANY_DATA_VALID,
        ];
      }
      if (this.pageInfo.PHONE_APPEND != null) {
        this.sendData.PHONE_APPEND = this.pageInfo.PHONE_APPEND;
      }
      if (this.pageInfo.PHONE_NUMBER != null) {
        this.sendData.PHONE_NUMBER = this.pageInfo.PHONE_NUMBER;
      }
      if (this.pageInfo.GENERAL_INFO_WITH_STATCODES_INVALID_DATA != null) {
        this.invalidData = this.pageInfo.GENERAL_INFO_WITH_STATCODES_INVALID_DATA;
      }
      if (this.pageInfo.STUFF_COUNT != null) {
        this.stuffCount = String(this.pageInfo.STUFF_COUNT);
      }
    },
    checkUpdateStuff() {
      return (
        parseInt(this.stuffCount.split(" ").join("")) ==
          this.pageInfo.STUFF_COUNT &&
        this.pageInfo.PHONE_NUMBER == this.sendData.PHONE_NUMBER
      );
    },
  },
  async created() {
    this.sendData.INN = this.pageInfo.INN;
    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.sendData.ID = this.pageInfo.ID;
    this.fillInfo();
    this.validation();
  },
  updated() {
    this.validation();
    if (this.isUpdate || !this.checkUpdateStuff()) this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: left;
}
.left-column {
  width: 25%;
  vertical-align: top;
}
td {
  padding-left: 10px;
}
.input-line,
.telephone-lines {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 100%;
  position: relative;
}
.input-line:focus,
.necessary-valid:focus,
.necessary-unvalid:focus,
.telephone-lines:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
.necessary {
  color: red;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.necessary-unvalid {
  border: none;
  border-bottom: 1px solid red;
  width: 100%;
}
.necessary-valid {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
}
.data-is-right-checkboxes {
  text-align: center;
  padding: 5px 0px;
}
.telephone-lines {
  width: auto;
  margin-right: 5px;
}
</style>
